
import LazyHydrate from "vue-lazy-hydration";
import SpTestimonials from "~/components/v2/splash/sp-testimonials.vue";
import SpReviews from "~/components/v2/splash/sp-reviews.vue";
import SpLocations from "~/components/v2/splash/sp-locations.vue";
import SpAbbreviations from "~/components/v2/splash/sp-abbreviations.vue";
import SpTopPart from "~/components/v2/splash/sp-top-part.vue";

export default {
  components: {
    LazyHydrate,
    SpTopPart,
    SpTestimonials,
    SpBanner: () => import("~/components/v2/splash/sp-banner.vue"),
    SpReviews,
    SpLocations,
    SpPhotoGallery: () => import("~/components/v2/splash/sp-photo-gallery.vue"),
    SpVideoList: () => import("~/components/v2/splash/sp-video-list.vue"),
    SpAbbreviations,
  },

  layout: "splash",

  middleware: ["splash"],

  data() {
    return {
      load: false,
    };
  },

  async fetch({ store }) {
    await store.dispatch("sliders/getMainPageData");
  },

  computed: {
    isAuthenticated() {
      return this.$auth.loggedIn;
    },
    isMobile() {
      return this.$store.state.global.mobile;
    },
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {
      this.load = true;
      window.removeEventListener("scroll", this.handleScroll);
    },
  },
};
